<template>
  <v-tooltip bottom :disabled="!textTooLong">
    <template v-slot:activator="{ on: tooltip, attrs }">
      <span v-bind="{ ...attrs, ...$attrs }" v-on="{ ...tooltip, ...$listeners }">
        {{ textTruncated }}
      </span>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
// import Logger from '@/lib/Logger'

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    lengthMax: {
      type: Number,
      required: false,
      default: 32,
    },
  },

  data: () => ({
    //
  }),

  computed: {
    textTooLong() {
      return this.text.length > this.lengthMax
    },
    textTruncated() {
      if (this.textTooLong) {
        return this.text.slice(0, this.lengthMax) + '...'
      }
      return this.text
    },
  },

  methods: {
    //
  },
}
</script>

<style></style>
